
const BusinessForm = ({ formData, handleInputChange, errors }) => {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };

    return (
        <div>
            <h4>Business Information</h4>

            {/* Business Name */}
            <div className="single-box pt_15">
                <label className="inner-title" htmlFor="Business_Name">Business Name</label>
                <input
                    
                    type="text"
                    name="Business_Name"
                    value={formData.Business_Name || ""}
                    maxLength={40}
                    onChange={handleChange}
                    required
                />
                {errors.Business_Name && <span className="error">{errors.Business_Name}</span>}

            </div>

            {/* Business Address */}
            <div className="single-box">
                <label className="inner-title" htmlFor="Business_Address">Business Address</label>
                <input
                    
                    type="text"
                    name="Business_Address"
                    value={formData.Business_Address || ""}
                    onChange={handleChange}
                    required
                />
                <span className="error-message">{errors.Business_Address}</span>
            </div>

            <div className="row">
                {/* City */}
                <div className="col-xl-4">
                    <div className="single-box">
                        <label className="inner-title" htmlFor="_City">City</label>
                        <input
                            
                            type="text"
                            name="_City"
                            value={formData._City || ""}
                            maxLength={20}
                            onChange={handleChange}
                            required
                        />
                        <span className="error-message">{errors._City}</span>
                    </div>
                </div>

                {/* State */}
                <div className="col-xl-4">
                    <div className="single-box selectbox">
                        <label className="inner-title" htmlFor="_State">State</label>
                        <select
                           
                            name="_State"
                            value={formData._State || ""}
                            onChange={handleChange}
                            required
                        >
                            <option value="">State</option>
                            <option>Alabama</option>
                            <option>Alaska</option>
                            <option>Arizona</option>
                            <option>Arkansas</option>
                            <option>California</option>
                            <option>Colorado</option>
                            <option>Connecticut</option>
                            <option>Delaware</option>
                            <option>Florida</option>
                            <option>Georgia</option>
                            <option>Hawaii</option>
                            <option>Idaho</option>
                            <option>Illinois</option>
                            <option>Indiana</option>
                            <option>Iowa</option>
                            <option>Kansas</option>
                            <option>Kentucky</option>
                            <option>Louisiana</option>
                            <option>Maine</option>
                            <option>Maryland</option>
                            <option>Massachusetts</option>
                            <option>Michigan</option>
                            <option>Minnesota</option>
                            <option>Mississippi</option>
                            <option>Missouri</option>
                            <option>Montana</option>
                            <option>Nebraska</option>
                            <option>Nevada</option>
                            <option>New Hampshire</option>
                            <option>New Jersey</option>
                            <option>New Mexico</option>
                            <option>New York</option>
                            <option>North Carolina</option>
                            <option>North Dakota</option>
                        </select>
                        <span className="error-message">{errors._State}</span>
                    </div>
                </div>

                {/* Zip Code */}
                <div className="col-xl-4">
                    <div className="single-box">
                        <label className="inner-title" htmlFor="_Zipcode">Zip Code</label>
                        <input
                            
                            type="text"
                            name="_Zipcode"
                            value={formData._Zipcode || ""}
                            onChange={handleChange}
                            required
                        />
                        <span className="error-message">{errors._Zipcode}</span>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Business Phone Number */}
                <div className="col-xl-6">
                    <div className="single-box">
                        <label className="inner-title" htmlFor="Business_phone_number">Business Phone Number</label>
                        <input
                            
                            type="text"
                            name="Business_phone_number"
                            value={formData.Business_phone_number || ""}
                            onChange={handleChange}
                            required
                        />
                        <span className="error-message">{errors.Business_phone_number}</span>
                    </div>
                </div>

                {/* EIN */}
                <div className="col-xl-6">
                    <div className="single-box">
                        <label className="inner-title" htmlFor="_EIN">EIN</label>
                        <input
                            
                            type="text"
                            name="_EIN"
                            value={formData._EIN || ""}
                            onChange={handleChange}
                            required
                        />
                        <span className="error-message">{errors._EIN}</span>
                    </div>
                </div>
            </div>

            {/* Banking Needs */}
            <div className="single-box">
                <label className="inner-title">Are you interested in opening a checking/savings account?</label>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="appointment1"
                            value="yes"
                            checked={formData.appointment1 === "yes"}
                            onChange={handleChange}
                            required
                        />
                        Yes
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="appointment1"
                            value="no"
                            checked={formData.appointment1 === "no"}
                            onChange={handleChange}
                            required
                        />
                        No
                    </label>
                </div>
                {errors.appointment1 && <span className="error-message">{errors.appointment1}</span>}
            </div>


            <div className="single-box ">
                <label className="inner-title">Are you interested in a personal/business loan?</label>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="loanInterest"
                            value="yes"
                            checked={formData.loanInterest === "yes"}
                            onChange={handleInputChange}
                            required
                        />
                        Yes
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="loanInterest"
                            value="no"
                            checked={formData.loanInterest === "no"}
                            onChange={handleInputChange}
                            required
                        />
                        No
                    </label>
                </div>
                {errors.loanInterest && <span className="error-message">{errors.loanInterest}</span>}
            </div>



            {/* Banking Needs Description */}
            <div className="single-box">
                <label className="inner-title" htmlFor="_Describe">Please describe any other banking needs:</label>
                <input
                    
                    type="text"
                    name="_Describe"
                    value={formData._Describe || ""}
                    onChange={handleChange}
                    required
                />
                <span className="error-message">{errors._Describe}</span>
            </div>
        </div>
    );
};

export default BusinessForm;
